
import './App.css';


import { Navigationbar } from './layout/Navigationbar';
import { Home } from './component/Home';
import { Aboutus } from './component/Aboutus';
import { Services } from './component/Services';
import { Skill } from './component/Skill';
import { Projects } from './component/Projects';
import { Container } from 'react-bootstrap';
import { Footer } from './layout/Footer';
import { Contact } from './component/Contact';

import { BrowserRouter, Route, Router, Routes, useRoutes } from "react-router-dom";
import { Aboutpage } from './pages/Aboutpage';
import { Skillpage } from './pages/Skillpage';
import { Servicespage } from './pages/Servicespage';
import { Projectpage } from './pages/Projectpage';
import {Contactpage} from './pages/Contactpage'
import { Homepage } from './pages/Homepage';
function App() {
  return (

    <div className="App">


<BrowserRouter>
<Routes>
<Route path="/"  element ={<Homepage/>}/>
<Route path="/about"  element ={<Aboutpage/>}/>
<Route path="/skill"  element ={<Skillpage/>}/>
<Route path="/services"  element ={<Servicespage/>}/>
<Route path="/project"  element ={<Projectpage/>}/>
<Route path="/contact"  element ={<Contactpage/>}/>
         
</Routes>
  </BrowserRouter>


    </div>
  );
}

export default App;
